type ClassValue = string | number | false | null | undefined;

/** Minimal classnames combiner — avoids pulling in a dependency for this. */
export function cx(...values: ClassValue[]): string {
  return values.filter(Boolean).join(' ');
}
